import { withHeadlessPage } from './headless-render.js'

export const screenshot = async ({
  id = '',
  model = null,
  data = null,
  width = 0,
  height = 0,
  options = { encoding: 'base64' } as any,
  isThumbnail = false,
  context = {} as any,
  draft = false
} = {}) => {
  return withHeadlessPage(
    { id, model, data, width, height, options, context, draft, isThumbnail },
    page => page.screenshot(options)
  )
}
